import lang from "../assets/data/translations";
import lang_agent from "../assets/data/translation_agent";
import * as actions from "./Type";
export const Change_LangugeHeader = (lang) => {
  return (dispatch) => {
    if (lang === "Kurdish") {
      dispatch({
        type: actions.CHANGE_LANGE_KURDISH,
        payload: "krd",
      });
      // localStorage.setItem("lang", "krd");
      window.document.body.classList.add("rtl");
    } else if (lang === "Arabic") {
      dispatch({
        type: actions.CHANGE_LANGE_ARABIC,
        payload: "arb",
      });
      // localStorage.setItem("lang", "arb");
      window.document.body.classList.add("rtl");
    } else if (lang === "English") {
      dispatch({
        type: actions.CHANGE_LANGE_ENGLISH,
        payload: "en",
      });
      // localStorage.setItem("lang", "eng");
      window.document.body.classList.remove("rtl");
    }
  };
};
export const change_Lang = (key, el) => {
  return (dispatch, getState) => {
    if (
      getState().AuthReducer.user.role !== "agent" &&
      getState().AuthReducer.user.role !== "accountant"
    ) {
      key = lang.find((item) => item.user_key === key);
      if (getState().HelperReducer.lang === "krd") {
        return key != null ? (key = key.kurdish) : el;
      } else if (getState().HelperReducer.lang === "arb") {
        return key != null ? (key = key.arabic) : el;
      } else if (getState().HelperReducer.lang === "en") {
        return key != null ? (key = key.english) : el;
      }
    } else {
      key = lang_agent.find((item) => item.user_key === key);
      if (getState().HelperReducer.lang === "krd") {
        return key != null ? (key = key.kurdish) : el;
      } else if (getState().HelperReducer.lang === "arb") {
        return key != null ? (key = key.arabic) : el;
      } else if (getState().HelperReducer.lang === "en") {
        return key != null ? (key = key.english) : el;
      }
    }
  };
};

export const EveryTimeTo_English = (key) => {
  return (dispatch, getState) => {
    let languge;
    let arr = lang;
    let arr_agent = lang_agent;
    if (
      getState().AuthReducer.user.role !== "agent" &&
      getState().AuthReducer.user.role !== "accountant"
    ) {
      arr.map((el) => {
        if (el.kurdish === key) {
          languge = el.english;
        } else if (el.arabic === key) {
          languge = el.english;
        } else if (el.english === key) {
          languge = el.english;
        }
      });
    } else {
      arr_agent.map((el) => {
        if (el.kurdish === key) {
          languge = el.english;
        } else if (el.arabic === key) {
          languge = el.english;
        } else if (el.english === key) {
          languge = el.english;
        }
      });
    }

    return languge;
  };
};
